export const ProfileRoute = {
  path: "/profile",
  component: () => import("../views/profile.vue"),
  children: [
    { path: ":userId", component: () => import("../views/profile-user.vue") },
  ],
};
